import {
  OnboardingStatus,
  OnboardingStepType,
  OrganizationOverviewFragment,
} from '@alice-financial/alice-sdk'
import { getStep, ORDERED_ONBOARDING_STEP_TYPES } from './utils/onboardingWorkflowUtils'

export const useOrgOnboardingSummary = (
  org: OrganizationOverviewFragment
): Record<OnboardingStepType, OnboardingStatus | undefined> => {
  const onboardingWorkflow = org.onboardingWorkflow

  return ORDERED_ONBOARDING_STEP_TYPES.reduce<Record<OnboardingStepType, OnboardingStatus | undefined>>(
    (acc, stepType) => {
      acc[stepType] = getStep(onboardingWorkflow, stepType)?.status
      return acc
    },
    {} as Record<OnboardingStepType, OnboardingStatus | undefined>
  )
}
